// // Start: Plus add charge into price of product
// let formatter = new Intl.NumberFormat('en-US', {
//   style: 'currency',
//   currency: 'USD',
// });

// let originPriceText = null;
// let originPrice = null;
// let interval3 = setInterval(function () {
//   let ap_elements = document.querySelector('#avpoptions-container__v2');
//   if (ap_elements) {
//     if (!originPriceText) {
//       originPriceText = $('.price-item.price-item--regular')[0].innerHTML;
//       originPrice = parseFloat($('.price-item.price-item--regular')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
//     }	
//     if (originPriceText && originPrice && $('#avp-productoption-total-add').is(':visible')){
//       let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
//       let newPrice = originPrice + addChargePrice;
//       $('.price-item.price-item--regular')[0].innerHTML = formatter.format(newPrice);

//     } else {
//       $('.price-item.price-item--regular')[0].innerHTML = originPriceText;
//     }
//   } 
// }, 100);
// // End: Plus add charge into price of product

// Start: Plus add charge into price of product
let formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

let interval3 = setInterval(function () {
  let originPriceText = null;
  let originPrice = null;
  let ap_elements = document.querySelector('#avpoptions-container__v2');
  if (ap_elements) {
    if (!originPriceText) {
      originPriceText = $('.price-item.price-item--regular')[0].innerHTML;
      originPrice = parseFloat($('.price-item.price-item--regular')[0].innerHTML.replace('£', '').replace(/[^\d.]/g, ''));
    }	
    if ($('#avp-productoption-total-add').is(':visible')){
      let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('£', '').replace(/[^\d.]/g, ''));
      let newPrice = originPrice + addChargePrice;
      $('.avpo-price-item.price-item.price-item--regular')[0].innerHTML = formatter.format(newPrice);
      $($('.price-item.price-item--regular')[0]).css('display', 'none');
    } else {
      $('.avpo-price-item.price-item.price-item--regular')[0].innerHTML = originPriceText;
      $($('.price-item.price-item--regular')[0]).css('display', 'none');
    }
  } 
}, 100);
// End: Plus add charge into price of product